import { FacebookPixel } from 'components/consent-restricted-scripts/FacebookPixel';
import { GoogleAdServices } from 'components/consent-restricted-scripts/GoogleAdServices';
import { GoogleAnalytics } from 'components/consent-restricted-scripts/GoogleAnalytics';

import { getEnv } from 'selectors/appSelector';
import { useSelector } from 'react-redux';
import Amplitude from 'components/consent-restricted-scripts/Amplitude';
import React from 'react';

export const ConsentRestrictedScripts: React.FunctionComponent = () => {
  const env = useSelector(getEnv);

  // Important - check for window object to ensure scripts aren't loaded on server render
  return (
    <>
      {typeof window !== 'undefined' && env !== 'dev' ? (
        <>
          <FacebookPixel />
          <GoogleAnalytics />
          <GoogleAdServices />
        </>
      ) : null}
      {typeof window !== 'undefined' && (
        <>
          <Amplitude />
        </>
      )}
    </>
  );
};
